class FfTabs extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.ff-tab-container')
    this.tabs.forEach((tab) => {
      if(tab.dataset.open === 'true') tab.classList.add('ff-show-tab') 
      tab.querySelector('.ff-tab-title-container').addEventListener('click', (event) => {
        tab.classList.toggle('ff-show-tab')
      })
    })
  }
}
customElements.define('ff-tabs', FfTabs)